import React from "react";

import CookieAuthProvider from "./CookieAuthProvider";
import MsalAuthProvider from "./MsalAuthProvider";
import { isRunningInMobileApp, useEnvironment } from "../hooks";

export type AuthProviderProps = {
  children: React.ReactNode;
};

export function AuthProvider({ children }: AuthProviderProps) {
  const env = useEnvironment();

  return isRunningInMobileApp(env) ? (
    <CookieAuthProvider>{children}</CookieAuthProvider>
  ) : (
    <>
      <MsalAuthProvider>{children}</MsalAuthProvider>
    </>
  );
}
